








import { Component, Vue } from 'vue-property-decorator';

@Component
export default class App extends Vue {
  private mounted() {
    this.$vuetify.theme.dark = false;
  }
}
